//ts =================================================
import "./Util/Prototypes";

import * as Util from "./Util/Util";

export let address: string;
export let commInfo: string;
export let mapExtent: string;
export let mapTheme: string;
export let pin: string;
export let startupTool: string;

export let zoomToStartExtent: boolean = true; //Zoom to start extent if not processing query string.

//Setters.
export function setAddress(full_address: string) {
   address = full_address;
}
export function setCommInfo(communityInfo: string) {
   commInfo = communityInfo;
}
export function setMapExtent(mbr: string) {
   mapExtent = mbr;
}
export function setMapTheme(mapThemeName: string) {
   mapTheme = mapThemeName;
}
export function setPIN(parcelID: string) {
   pin = parcelID;
}
export function setStartupTool(toolName: string) {
   startupTool = toolName;
}
export function setZoomToStartExtent(zoomTo: boolean) {
   zoomToStartExtent = zoomTo;
}

//Get query strings.
export function getAll() {
   Util.logMsg('Getting query strings.');

   address = Util.getQueryString("address");
   commInfo = Util.getQueryString("commInfo");  //Needs work
   mapExtent = Util.getQueryString("mapExtent");
   mapTheme = Util.getQueryString("mapTheme");
   pin = Util.getQueryString("pin");
   startupTool = Util.getQueryString("startupTool");

   if (address || commInfo || pin) {
      zoomToStartExtent = false;
   }
}
